const th = {
  lead: "ครอบครัว นักเดินป่า นักสกี และนักท่องเที่ยวตามล่าโทรลล์ด้วยการเดิน เล่นสกี และนั่งเรือ วางโทรลล์ไว้หน้าประตูของคุณ แล้วการล่าจะพาลูกค้าใหม่มาหาคุณโดยตรง — ไม่ว่าคุณจะทำธุรกิจแบบไหน",
  areasKicker: "ประเภทธุรกิจ",
  areasTitle: "ค้นหาประเภทธุรกิจของคุณ",
  bannerKicker: "มีธุรกิจในด้านนี้ใช่ไหม?",
  bannerTitle: "ได้ลูกค้ามากขึ้น ดึงดูดผู้มาเยือนใหม่",
  cta: "มาเป็นพันธมิตรกับ Trollfossjakten",
  placesLike: "เหมาะกับสถานที่อย่าง",
  ideaTitle: "ไอเดียโทรลล์",
  cats: {
    hotels: {
      name: "โรงแรมและเครือโรงแรม",
      short: "เปลี่ยนนักล่าโทรลล์ให้เป็นแขกที่ค้างคืน",
      lead: "โทรลล์ที่ทางเข้า ในสวน หรือบนเส้นทางของโรงแรมเอง ทำให้ครอบครัวมีเหตุผลที่จะค้างคืน — และกลับมาอีกในฤดูกาลหน้า",
      idea: "โทรลล์พนักงานยกกระเป๋าที่หน้าประตู โทรลล์อาหารเช้าข้างหน้าต่างบุฟเฟต์ และโทรลล์ราตรีใต้แสงเหนือบนดาดฟ้า",
      types: ["เครือโรงแรม", "โรงแรมเก่าแก่", "โรงแรมริมฟยอร์ดและบนภูเขา", "รีสอร์ตและสปา", "โรงแรมริมชายฝั่ง", "กระท่อมและลอดจ์"],
    },
    restaurants: {
      name: "ร้านอาหารและเครือคาเฟ่",
      short: "นักล่าที่หิวโหย อยู่หน้าร้านคุณแล้ว",
      lead: "การล่าโทรลล์ทำให้คนหิว วางโทรลล์ไว้ที่ร้านอาหารของคุณ แล้วให้ผู้เล่นสั่งล่วงหน้าและจ่ายผ่าน Vipps ระหว่างทาง",
      idea: "โทรลล์เชฟกำลังคนซุป โทรลล์พิซซ่าบนระเบียง และโทรลล์กาแฟที่เฝ้าที่นั่งริมหน้าต่างที่ดีที่สุด",
      types: ["เครือร้านพิซซ่าและเบอร์เกอร์", "เครือร้านกาแฟ", "สเต๊กเฮาส์", "ร้านอาหารครอบครัว", "ซูชิและอาหารเอเชีย", "เครือร้านเบเกอรี่"],
    },
    activities: {
      name: "กิจกรรมและประสบการณ์",
      short: "อีกหนึ่งเหตุผลให้นักผจญภัยจองกับคุณ",
      lead: "ทริปฟยอร์ด ล่องแก่ง ซาฟารี และเดินป่ากับไกด์ คือดินแดนในฝันของโทรลล์ โทรลล์ของคุณเปลี่ยนทัวร์ให้เป็นภารกิจ — และพาผู้เล่นมาที่เคาน์เตอร์จองของคุณ",
      idea: "โทรลล์ใส่เสื้อชูชีพที่ท่าเรือคายัค โทรลล์ธารน้ำแข็งบนน้ำแข็ง และโทรลล์แสงเหนือที่ปรากฏตัวเฉพาะในซาฟารีฤดูหนาว",
      types: ["ทัวร์ฟยอร์ดและล่องเรือ", "การเดินเรือเลียบชายฝั่ง", "ล่องแก่งและคายัค", "ซาฟารีอาร์กติกและแสงเหนือ", "ทริปผจญภัย", "ศูนย์ธรรมชาติป่า"],
    },
    ski: {
      name: "รีสอร์ตสกีและจุดหมายบนภูเขา",
      short: "โทรลล์บนลานสกี ตลอดฤดูหนาว",
      lead: "โทรลล์ข้างลิฟต์ บนเส้นทางสกีครอสคันทรี และที่คาเฟ่บนยอดเขา ทำให้ทุกวันเล่นสกีกลายเป็นการล่า — และพาครอบครัวกลับมาในฤดูร้อนด้วย",
      idea: "โทรลล์สกีบนสกีไม้โบราณข้างลิฟต์ โทรลล์หิมะในเส้นทางป่า และโทรลล์ยอดเขาที่เสิร์ฟโกโก้ร้อน",
      types: ["รีสอร์ตสกีอัลไพน์", "ศูนย์สกีครอสคันทรี", "หมู่บ้านบนภูเขา", "สกีฤดูร้อน", "อาฟเตอร์สกีและลอดจ์", "โรงเรียนสอนสกี"],
    },
    attractions: {
      name: "สถานที่ท่องเที่ยวและพิพิธภัณฑ์",
      short: "ให้โทรลล์เล่าเรื่องราวของคุณ",
      lead: "โทรลล์เป็นส่วนหนึ่งของนิทานพื้นบ้านนอร์เวย์ วางพวกมันไว้ในสวนพิพิธภัณฑ์ ข้างโบสถ์ไม้สเตฟ หรือบนเส้นทางเดินป่าชื่อดัง แล้วผู้มาเยือนจะอยู่นานขึ้นและสำรวจมากขึ้น",
      idea: "โทรลล์นักเล่านิทานข้างบ้านไร่เก่า โทรลล์หัวมังกรบนโบสถ์ไม้สเตฟ และโทรลล์หน้าผาที่เฝ้าจุดชมวิว",
      types: ["พิพิธภัณฑ์กลางแจ้ง", "พิพิธภัณฑ์เรือและประวัติศาสตร์", "พิพิธภัณฑ์ศิลปะ", "โบสถ์ไม้สเตฟและมหาวิหาร", "อุทยานแห่งชาติ", "เส้นทางเดินป่าและจุดชมวิวชื่อดัง"],
    },
    transport: {
      name: "การขนส่งและเรือเฟอร์รี่",
      short: "ทำให้การเดินทางเป็นส่วนหนึ่งของการล่า",
      lead: "เรือเฟอร์รี่ เรือด่วน รถบัส และรถไฟ พานักเดินทางผู้อยากรู้อยากเห็นหลายพันคน โทรลล์บนเรือและที่ท่าเรือเปลี่ยนเวลารอให้เป็นเวลาเล่น",
      idea: "โทรลล์ทะเลโบกมือที่หัวเรือเฟอร์รี่ โทรลล์ตรวจตั๋วที่ป้ายรถบัส และโทรลล์อุโมงค์ที่พบได้เฉพาะบนรถไฟ",
      types: ["บริษัทเรือเฟอร์รี่", "เรือด่วน", "รถบัสระหว่างเมือง", "รถไฟ", "ขนส่งในเมือง", "ท่าเรือและสถานี"],
    },
    cafes: {
      name: "คาเฟ่และร้านเบเกอรี่",
      short: "ขนมปังสดใหม่ กาแฟร้อน — และโทรลล์หน้าประตู",
      lead: "โทรลล์เพียงตัวเดียวหน้าคาเฟ่ของคุณ ก็ชวนผู้เล่นเข้ามาดื่มกาแฟ กินวาฟเฟิลและซินนามอนโรล พวกเขาสั่งล่วงหน้าผ่าน Vipps และรับเมื่อมาถึงได้",
      idea: "โทรลล์คนทำขนมปังที่มีแป้งติดจมูก กำลังดมกลิ่นซินนามอนโรลผ่านหน้าต่าง",
      types: ["คาเฟ่ท้องถิ่น", "ร้านเบเกอรี่", "โรงคั่วกาแฟ", "สาขาร้านเบเกอรี่และกาแฟ", "ซุ้มไอศกรีม", "ร้านวาฟเฟิล"],
    },
    saunas: {
      name: "ซาวน่า",
      short: "อุ่นร่างกายหลังการล่า",
      lead: "หลังจากวันอันหนาวเหน็บบนเส้นทาง ไม่มีอะไรดีไปกว่าซาวน่าริมฟยอร์ด โทรลล์ซาวน่าพาผู้เล่นมาที่ประตูของคุณ และพวกเขาจองเวลาผ่าน Vipps ได้",
      idea: "โทรลล์อารมณ์ดีห่มผ้าขนหนูลายทาง นั่งไอร้อนกรุ่นบนดาดฟ้าและท้าทุกคนให้กระโดดลงฟยอร์ด",
      types: ["ซาวน่าท้องถิ่น", "ซาวน่าลอยน้ำ", "ซาวน่าริมฟยอร์ด", "ชมรมซาวน่า", "สปาและโรงอาบน้ำ", "อ่างน้ำร้อนกลางแจ้ง"],
    },
    shops: {
      name: "ร้านค้าเล็กและผู้ผลิตท้องถิ่น",
      short: "ร้านเล็ก การค้นพบใหญ่",
      lead: "นักล่าโทรลล์ชอบซื้อของกลับบ้าน โทรลล์หนึ่งตัวที่ร้านของคุณ ทำให้ทุกคนที่ผ่านไปมาเห็นคุณบนแผนที่",
      idea: "โทรลล์เจ้าของร้านถือตะกร้าเต็มไปด้วยแยม ชีส และถุงเท้าขนสัตว์",
      types: ["ร้านค้าในฟาร์ม", "ร้านของที่ระลึกและงานฝีมือ", "โรงเบียร์และโรงกลั่น", "ร้านอุปกรณ์ตกปลาและเอาท์ดอร์", "ร้านหนังสือและร้านของขวัญ", "ร้านขายของชำ กีฬา และฮาร์ดแวร์"],
    },
  },
};

export default th;
